import Exception from './Exception';
import SR from '../i18n/en/exceptions.strings.json';
export default class MutexAlreadyAquiredException extends Exception {
    constructor(message, innerException) {
        if (innerException) {
            super(message, innerException);
        }
        else {
            if (message) {
                super(message);
            }
            else {
                super(SR.MutexAlreadyAquiredException_message);
            }
        }
        this.name = 'InvalidOperationException';
    }
}
